import React from "react";
import {LANG_KEY} from "../../constants";

export interface LangContextProps {
  lang: string
  handleChangeLang: (value: string) => void
}

const initialState: LangContextProps = {
  lang: LANG_KEY.RU,
  handleChangeLang: (value: string) => {
  }
}

export const LangContext = React.createContext<LangContextProps>(initialState)
